import React, { useEffect, useState, useRef } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { Link } from "react-router-dom";
import { Icon } from "@iconify/react";
export default function Footer() {
	useEffect(() => {
		AOS.init({
			duration: 500,
			easing: "ease-in-out",
			once: true,
		});
	}, []);

	const [openMenu, setOpenMenu] = useState(null);
	const [showSizeChart, setShowSizeChart] = useState("");
	const [zoomed, setZoomed] = useState(false);
	const [isZoomActive, setIsZoomActive] = useState(false);
	const [zoomPosition, setZoomPosition] = useState({ x: 50, y: 50 });
	const imageRef = useRef(null);

	const toggleMenu = (menu) => {
		setOpenMenu(openMenu === menu ? null : menu);
	};

	const promOptions = [
		{ label: "2026 Collection", value: "/prom/2026" },
		{ label: "2025 Collection", value: "/prom/2025" },
		{ label: "Size Chart", value: "sizeChart" },
	];

	// Size Chart handler
	const handleSizeChart = () => {
		setShowSizeChart("Prom");
	};

	// Zoom effect handlers
	const handleMouseMove = (e) => {
		if (!imageRef.current) return;

		const rect = imageRef.current.getBoundingClientRect();
		const x = (e.nativeEvent.offsetX / rect.width) * 100;
		const y = (e.nativeEvent.offsetY / rect.height) * 100;
		setZoomPosition({ x, y });
	};

	const handleMouseEnter = () => {
		setIsZoomActive(true);
	};

	const handleMouseLeave = () => {
		setIsZoomActive(false);
	};

	// Helper function to apply the transition classes
	const getDropdownClasses = (menuName) => {
		const baseClasses =
			"ml-4 mt-2 flex flex-col gap-1 overflow-hidden transition-all duration-300 ease-in-out";
		const isOpen = openMenu === menuName;
		const heightClass = isOpen ? "max-h-40 opacity-100" : "max-h-0 opacity-0";
		return `${baseClasses} ${heightClass}`;
	};

	return (
		<>
			{/* 🧭 SIZE CHART MODAL */}
			{showSizeChart && (
				<div className="fixed inset-0 h-screen bg-black bg-opacity-70 flex items-center justify-center z-[1200] p-4">
					<div className="">
						<button
							onClick={() => setShowSizeChart("")}
							className="absolute top-3 right-3 text-gray-200 hover:text-blue-600 transition">
							<Icon icon="heroicons:x-mark-20-solid" className="w-7 h-7" />
						</button>

						{/* Zoom Toggle Button */}
						<button
							onClick={() => setZoomed((prev) => !prev)}
							className="absolute top-3 left-3 text-gray-200 hover:text-blue-600 transition">
							<Icon
								icon={
									zoomed
										? "mdi:magnify-minus-outline"
										: "mdi:magnify-plus-outline"
								}
								className="w-7 h-7"
							/>
						</button>
					</div>
					<div className="bg-transparent w-full flex flex-col justify-center items-center gap-5 relative">
						{/* Image Container */}
						<div
							className={`w-full h-full max-h-[90vh] overflow-x-auto overflow-y-hidden flex justify-center ${
								zoomed ? "cursor-grab" : ""
							}`}>
							{/* Zoomable Image */}
							<div
								ref={imageRef}
								className="md:w-[70%]   w-[100%]  h-auto max-h-[600px]  relative overflow-hidden rounded-2xl bg-gray-50"
								style={{
									height: "auto",
								}}
								onMouseMove={handleMouseMove}
								onMouseEnter={handleMouseEnter}
								onMouseLeave={handleMouseLeave}>
								{/* Main Image */}
								<img
									src="https://azuredress.com/static/media/sizechart.ea2456da397131b84a82.jpeg"
									alt="Prom Size Chart"
									className={`transition-transform duration-300 w-full h-full object-contain px-5 ${
										zoomed ? "scale-110" : "scale-100"
									}`}
									style={{
										transformOrigin: "center center",
										minWidth: zoomed ? "130%" : "auto",
									}}
								/>

								{/* Zoom Overlay */}
								<div
									className="absolute inset-0 transition-opacity duration-300"
									style={{
										opacity: isZoomActive ? 1 : 0,
										backgroundImage: `url(https://azuredress.com/static/media/sizechart.ea2456da397131b84a82.jpeg)`,
										backgroundSize: "200%",
										backgroundPosition: `${zoomPosition.x}% ${zoomPosition.y}%`,
										pointerEvents: "none",
									}}
								/>
								<div
									className={`absolute bottom-4 right-4 bg-blue-600 text-white w-[50px] flex items-center justify-center px-0 py-[14px] rounded-full text-sm transition-all duration-300 ${
										isZoomActive ? "opacity-100" : "opacity-0"
									}`}>
									<Icon icon="iconamoon:zoom-in-light" width="20" height="20" />
								</div>
							</div>

							{/* Zoom Icon */}
						</div>
					</div>
				</div>
			)}

			{/* MAIN FOOTER CONTENT */}
			<div className="w-full bg-[#1f4c94] overflow-x-hidden py-10 border-b">
				<div className="w-full md:px-10 px-6 lg:px-16 grid lg:grid-cols-4 md:grid-cols-2 gap-5 ">
					{/* Newsletter Section */}
					<div
						className="flex justify-center items-start text-white flex-col lg:px-10 md:px-4 md:py-2 lg:py-6"
						data-aos="fade-left">
						<h2 className="text-3xl font-lora my-4">Let's get in Touch</h2>
						<p className="font-poppins text-[14px]">
							Sign up for our newsletter and get news about latest products and
							discounts
						</p>
						<input
							type="text"
							placeholder="Enter Your Email Address..."
							className="text-white placeholder:text-white font-poppins px-3 w-full outline-none border-2 bg-inherit text-[16px] py-2 rounded-lg my-5 border-white hover:bg-white hover:bg-opacity-25 transition-all duration-300 focus:bg-white focus:bg-opacity-25"
						/>
					</div>

					{/* Store Links Section */}
					<div
						data-aos="fade-left"
						className="text-white font-Jost-Regular md:px-5 lg:px-5 flex flex-col gap-2 py-6 md:py-10 lg:py-14">
						<h2 className="font-lora mb-2 font-medium text-[20px]">
							Website Links
						</h2>
						<p className="font-poppins">
							<Link
								to="/"
								className="block py-1 px-2 rounded transition-all duration-300 hover:bg-white hover:bg-opacity-25 hover:px-2">
								Home
							</Link>
						</p>

						{/* Prom Dropdown */}
						<div className="font-poppins">
							<button
								onClick={() => toggleMenu("prom")}
								className="flex justify-between items-center w-full py-1 px-2 rounded transition-all duration-300 hover:bg-white hover:bg-opacity-25 hover:px-2">
								Prom{" "}
								<span>
									{openMenu === "prom" ? (
										<Icon icon="ep:arrow-up" width="20" height="20" />
									) : (
										<Icon icon="ep:arrow-down" width="20" height="20" />
									)}
								</span>
							</button>
							<div className={getDropdownClasses("prom")}>
								{promOptions.map((item) =>
									item.value === "sizeChart" ? (
										<button
											key={item.value}
											onClick={handleSizeChart}
											className="py-1 px-2 rounded transition-all duration-300 hover:bg-white hover:bg-opacity-25 hover:px-3 text-left w-full">
											{item.label}
										</button>
									) : (
										<Link
											key={item.value}
											to={item.value}
											className="py-1 px-2 rounded transition-all duration-300 hover:bg-white hover:bg-opacity-25 hover:px-3">
											{item.label}
										</Link>
									)
								)}
							</div>
						</div>
					</div>

					{/* Contact Section */}
					<div
						data-aos="fade-left"
						className="text-white font-Jost-Regular md:px-5 lg:px-5 flex flex-col gap-2 py-6 md:py-10 lg:py-14">
						<h2 className="font-lora mb-2 font-medium text-[20px]">
							Contact Links
						</h2>
						<p className="font-poppins">
							<Link
								to="/about"
								className="block py-1 px-2 rounded transition-all duration-300 hover:bg-white hover:bg-opacity-25 hover:px-2">
								About Us
							</Link>
						</p>
						<p className="font-poppins">
							<Link
								to="/contact"
								className="block py-1 px-2 rounded transition-all duration-300 hover:bg-white hover:bg-opacity-25 hover:px-2">
								Contact Us
							</Link>
						</p>
						<p className=" border-[1px] border-white rounded-md w-fit p-2">
							<Link
								to="https://market.azuredress.com/"
								className="flex items-center gap-1 text-white hover:text-gray-300 transition">
								<Icon icon="qlementine-icons:user-16" width="20" height="20" />
								<span className="text-sm font-medium">RETAILER LOGIN</span>
							</Link>
						</p>
					</div>

					{/* Social Section */}
					<div
						data-aos="fade-left"
						className="text-white md:px-5 lg:px-5 flex flex-col gap-2 py-6 md:py-10 lg:py-14">
						<h2 className="font-lora mb-2 font-medium text-[20px]">
							Social Links
						</h2>
						<p className="font-poppins hover:bg-white hover:bg-opacity-25 py-1 px-2 rounded transition-all duration-300 cursor-default">
							<Link
								to={
									"https://www.instagram.com/azuredress?igsh=MXhoNzZ2N3hqbjgyeA=="
								}>
								Instagram
							</Link>
						</p>
					</div>
				</div>
			</div>
		</>
	);
}
